import * as ActionTypes from '../constants/actionTypes';

export const initialState = {
    request: false,
    error: '',
    data: [],
};

export default function bestPrice(state = initialState, action) {

    switch (action.type) {
        case ActionTypes.BEST_PRICE_REQUEST:
            return {
                ...state,
                request: true,
                error: '',
            };

        case ActionTypes.BEST_PRICE_SUCCESS:
            return {
                ...state,
                request: false,
                error: '',
                data: action.payload
            };

        case ActionTypes.BEST_PRICE_ERROR:
            return {
                ...state,
                request: false,
                error: action.payload
            };

        default :
            return state;
    }

}